export const friends = [
    { id: 1, image: "/assets/person/1.jpeg", name: "محمد سايس", lastSeen: 0 },
    { id: 2, image: "/assets/person/2.jpeg", name: "أحمد بن صالح", lastSeen: 5 },
    {
        id: 3,
        image: "/assets/person/3.jpeg",
        name: "فاطمة الزهراء",
        lastSeen: 10,
    },
    { id: 4, image: "/assets/person/4.jpeg", name: "يوسف علي", lastSeen: 15 },
    { id: 5, image: "/assets/person/5.jpeg", name: "سارة محمد", lastSeen: 20 },
    {
        id: 6,
        image: "/assets/person/6.jpeg",
        name: "خالد عبد الله",
        lastSeen: 25,
    },
    { id: 7, image: "/assets/person/7.jpeg", name: "ليلى حسن", lastSeen: 0 },
    { id: 8, image: "/assets/person/8.jpeg", name: "أيمن زكريا", lastSeen: 35 },
    { id: 9, image: "/assets/person/9.jpeg", name: "نادية يوسف", lastSeen: 0 },
    { id: 10, image: "/assets/person/10.jpeg", name: "عمر سليمان", lastSeen: 45 },
];